import api from './axios';

export const listGizmosGames = (params) => api.get('/gizmos/', { params });
export const getGizmosGame = (id) => api.get(`/gizmos/${id}/`);
export const createGizmosGame = (data) => api.post('/gizmos/', data);
export const getGizmosGameState = (id) => api.get(`/gizmos/${id}/state/`);
export const joinGizmosGame = (id) => api.post(`/gizmos/${id}/join/`);
export const leaveGizmosGame = (id) => api.post(`/gizmos/${id}/leave/`);
export const readyGizmosGame = (id) => api.post(`/gizmos/${id}/ready/`);
export const startGizmosGame = (id) => api.post(`/gizmos/${id}/start/`);

export const performGizmosAction = (id, type, payload, stateVersion) =>
  api.post(`/gizmos/${id}/action/`, { type, payload, state_version: stateVersion });
